/* eslint-disable object-shorthand */
import { component } from "picoapp";
import $ from "jquery";

export default component((node) => {
  $(node).on({
    mouseenter: function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      const $selected = $(this).find("is-selected");
      if ($selected.length) {
        $selected.find(".alt-image").first().addClass("is-hover");
      } else {
        $(this).find(".alt-image").addClass("is-hover");
      }
    },
    mouseleave: function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      $(".alt-image").removeClass("is-hover");
    },
    touchstart: function (ev) {
      if (!window.matchMedia("(max-width: 749px)").matches) {
        return;
      }

      $(this).data("moved", "0");
      $(this).find(".alt-image").addClass("is-tapped");
      $(this).closest(".product-item").addClass("is-tapped");
      $(this).find(".product-item__tag").addClass("is-tapped");
    },
    touchmove: function () {
      if (!window.matchMedia("(max-width: 749px)").matches) {
        return;
      }

      $(this).data("moved", "1");
    },
    touchend: function () {
      if (!window.matchMedia("(max-width: 749px)").matches) {
        return;
      }

      $(this).find(".alt-image").removeClass("is-tapped");
      $(this).closest(".product-item").removeClass("is-tapped");
      $(this).find(".product-item__tag").removeClass("is-tapped");
    },
  });
});
